import API_BASE_URL from "../../../../../Constants";

export const updateManagementCompany = async (managementId, data) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/managementcompanies/${managementId}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(data),
      }
    );
    return response.status === 200;
  } catch (error) {
    console.error("Failed to save management company:", error);
    throw error;
  }
};
